/**
 * E2E Test Data Enums
 *
 * These enums define the test data used in E2E tests and seed scripts.
 * They ensure consistency between backend seed data and frontend E2E tests.
 */
/**
 * E2E Test User Email Addresses
 * Used to identify specific test users in E2E tests
 */
export var E2E_TEST_USER_EMAILS;
(function (E2E_TEST_USER_EMAILS) {
    E2E_TEST_USER_EMAILS["OWNER"] = "e2e-test-owner@bdev.com.br";
    E2E_TEST_USER_EMAILS["ADMIN"] = "e2e-test-admin@bdev.com.br";
    E2E_TEST_USER_EMAILS["MANAGER"] = "e2e-test-manager@bdev.com.br";
    E2E_TEST_USER_EMAILS["MEDICAL_PROFESSIONAL"] = "e2e-test-medical-professional@bdev.com.br";
    E2E_TEST_USER_EMAILS["ACCOUNTANT"] = "e2e-test-accountant@bdev.com.br";
    E2E_TEST_USER_EMAILS["VIEWER"] = "e2e-test-viewer@bdev.com.br";
    E2E_TEST_USER_EMAILS["MULTI_ORG_USER"] = "e2e-test-multi-org-user@bdev.com.br";
})(E2E_TEST_USER_EMAILS || (E2E_TEST_USER_EMAILS = {}));
/**
 * E2E Test Establishment Names
 * Used to identify specific test establishments in E2E tests
 */
export var E2E_ESTABLISHMENT_NAMES;
(function (E2E_ESTABLISHMENT_NAMES) {
    E2E_ESTABLISHMENT_NAMES["MAIN_STUDIO"] = "Farm 001";
    E2E_ESTABLISHMENT_NAMES["DOWNTOWN_BRANCH"] = "Farm 002";
    E2E_ESTABLISHMENT_NAMES["NORTH_LOCATION"] = "Farm 003";
})(E2E_ESTABLISHMENT_NAMES || (E2E_ESTABLISHMENT_NAMES = {}));
/**
 * E2E Test Organization Names
 * Used to identify specific test organizations in E2E tests
 */
export var E2E_ORGANIZATION_NAMES;
(function (E2E_ORGANIZATION_NAMES) {
    E2E_ORGANIZATION_NAMES["BLANK"] = "E2E Farm Blank";
    E2E_ORGANIZATION_NAMES["PLAN_STARTER"] = "E2E Farm Plan Starter";
    E2E_ORGANIZATION_NAMES["PLAN_PROFESSIONAL"] = "E2E Farm Plan Professional";
    E2E_ORGANIZATION_NAMES["PLAN_ENTERPRISE"] = "E2E Farm Plan Enterprise";
    /**
     * The only seeded organization whose `defaultLanguage` is not `en_US`.
     * Exists so any locale-dependent path — media-analysis output language
     * (RT-11) above all — has something to exercise locally: every other seeded
     * org takes the column default and would pass an en_US-only implementation.
     */
    E2E_ORGANIZATION_NAMES["LANGUAGE_PT_BR"] = "E2E Farm Idioma pt-BR";
})(E2E_ORGANIZATION_NAMES || (E2E_ORGANIZATION_NAMES = {}));
//# sourceMappingURL=E2ETestData.js.map